import { S3StoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/s3-store-read-settings';
import { Metamodel, SapDatasphereForAmazons3LinkedService } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapDatasphereForAmazonS3.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(SapDatasphereForAmazons3LinkedService)
    }
})
export class SapDatasphereForAmazonS3ReadSettings extends S3StoreReadSettings {}
